exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@media (max-width:37.4rem){.SaveDialogLayout_hide-sm__xakpY{display:none!important}}@media (min-width:37.4rem){.SaveDialogLayout_visible-sm__1TaHc{display:none!important}}@media (max-width:79.9rem){.SaveDialogLayout_hide-md__Jfwt2{display:none!important}}@media (min-width:79.9rem){.SaveDialogLayout_visible-md__qLvIy{display:none!important}}.SaveDialogLayout_errorsContainer__UA1uK{flex:none}.SaveDialogLayout_content__2gmCr{flex:auto;display:flex;flex-direction:column}.SaveDialogLayout_content__2gmCr>*{flex:auto}", ""]);

// exports
exports.locals = {
	"hide-sm": "SaveDialogLayout_hide-sm__xakpY",
	"hideSm": "SaveDialogLayout_hide-sm__xakpY",
	"visible-sm": "SaveDialogLayout_visible-sm__1TaHc",
	"visibleSm": "SaveDialogLayout_visible-sm__1TaHc",
	"hide-md": "SaveDialogLayout_hide-md__Jfwt2",
	"hideMd": "SaveDialogLayout_hide-md__Jfwt2",
	"visible-md": "SaveDialogLayout_visible-md__qLvIy",
	"visibleMd": "SaveDialogLayout_visible-md__qLvIy",
	"errorsContainer": "SaveDialogLayout_errorsContainer__UA1uK",
	"content": "SaveDialogLayout_content__2gmCr"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&camelCase&importLoaders=1&localIdentName=[name]_[local]__[hash:base64:5]!./node_modules/less-loader/dist/cjs.js!./app/components/DialogLayout/Custom/SaveDialogLayout.less
// module id = 2069
// module chunks = 8